var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRhinovideoConnectionError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "75px",
    viewBox: "0 0 128 75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#0075C9",
    strokeWidth: 2,
    fill: "#EFF7FB",
    x: 29.6113601,
    y: 39.44,
    width: 46.1077552,
    height: 34,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#0075C9",
    strokeWidth: 2,
    fill: "#EFF7FB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "94.0439923 73.44 79.8569907 60.69 79.8569907 52.19 94.0439923 39.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6113601,58.5489744 C107.207714,58.5489744 112.715689,57.9733681 116.135286,56.8221555 C121.26468,55.0953367 126.160526,49.7710489 126.784212,45.1819848 C127.413318,40.5530344 125.635455,36.217451 122.61551,33.2886853 C121.419089,32.128386 118.041327,29.8070568 113.914339,28.6602206 C112.331044,28.2202438 109.711253,27.8338251 106.054964,27.5009645 C103.697704,24.3645054 101.241846,22.378335 98.6873887,21.5424532 C94.8557024,20.2886304 89.8946962,21.2334812 88.5703444,21.2334812 C87.7438664,21.2334812 87.8357789,13.982568 82.1677566,8.10890009 C78.7533172,4.57057906 72.7017056,1.35751956 64.6452956,1.02353798 C58.4661243,0.767378054 53.7554162,2.63634843 50.2595534,4.95661199 C47.0932561,7.05813739 43.7739202,12.0531835 40.3015456,19.9417503 C35.5193191,17.048909 30.6225905,16.4253264 25.6113601,18.0710028 C20.6001296,19.7166791 17.9096185,22.8599997 17.5398269,27.5009645 C13.6013727,28.7744529 10.8442112,29.9018472 9.26834249,30.8831473 C4.59995666,33.7901707 1.59407502,37.7984234 1.10525656,41.2907728 C0.585427618,45.0046756 2.0237162,49.085172 4.69729757,52.1830522 C7.70433442,55.6673074 13.0478662,57.6994514 15.1242995,58.2664974 C15.9324335,58.4871879 19.1734939,58.897725 24.8611159,59",
    stroke: "#0075C9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8863601,59.19625 C48.3738601,60.2525 48.3738601,61.30875 48.0488601,62.28375 L49.5926101,62.8525 C50.0801101,61.47125 50.0801101,59.9275 49.4301101,58.465 C48.7801101,57.0025 47.5613601,56.0275 46.1801101,55.54 L45.6113601,57.08375 C46.5863601,57.49 47.4801101,58.22125 47.8863601,59.19625 Z",
    fill: "#CC2D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4551101,51.72125 L47.8863601,53.265 C49.6738601,53.915 51.1363601,55.215 52.0301101,57.08375 C52.9238601,58.9525 52.9238601,60.9025 52.2738601,62.69 L53.8176101,63.25875 C54.6301101,61.14625 54.5488601,58.6275 53.4926101,56.43375 C52.4363601,54.0775 50.5676101,52.53375 48.4551101,51.72125 Z",
    fill: "#CC2D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7426101,55.0525 C58.3676101,58.54625 58.4488601,62.28375 57.2301101,65.615 L58.7738601,66.18375 C60.0738601,62.5275 60.0738601,58.22125 58.2051101,54.4025 C56.4176101,50.5025 53.1676101,47.74 49.5113601,46.44 L48.9426101,47.98375 C52.2738601,49.12125 55.1176101,51.64 56.7426101,55.0525 Z",
    fill: "#CC2D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.6968385,
    y1: 49.44,
    x2: 41.6113601,
    y2: 63.4839183,
    stroke: "#CC2D32",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhinovideoConnectionError);
export default __webpack_public_path__ + "static/media/rhinovideo-connection-error.74cb47ad.svg";
export { ForwardRef as ReactComponent };